import { Category } from "../../types";
import Heading from "../Heading";
import CategoryCard from "./CategoryCard";

interface Props {
  className?: string;
  onCategoryClick: (category: Category) => void;
  categories: Category[];
  includeHeading?: boolean;
  selectedCategoryId: Category["id"] | null;
}

const CategoryList = ({
  className = "",
  onCategoryClick,
  includeHeading,
  categories,
  selectedCategoryId,
}: Props) => {
  return (
    // IMPORTANT: min-h-0 so the flex child can shrink and allow overflow to work
    <div className={`flex flex-col h-full min-h-0 ${className}`}>
      {/** Heading */}
      {includeHeading && (
        <Heading
          className="max-w-[490px] pl-14"
          titleWords={[
            {
              content: "Los Santos",
              colorGradient:
                "linear-gradient(to right, rgba(56, 234, 245, 0.5), rgba(56, 234, 245, 1), rgba(56, 234, 245, 0.5))",
            },
            {
              content: "Customs",
              colorGradient:
                "linear-gradient(to right, rgba(196, 56, 245, 1), rgba(245, 56, 56, 0.5))",
            },
          ]}
          description="Lorem ipsum dolor sit amet consectetur adipiscing elit, sad de elisoum heyzdev temp indut lobare et dolare magna aliqua."
        />
      )}

      {/** List:
          - flex-1 to take remaining space
          - min-h-0 + overflow-y-auto so scrolling works inside flex/grid
      */}
      <ul className="space-y-0 mt-3 flex-1 overflow-auto  min-h-0 scrollbar-hide pl-14">
        {categories?.map((category) => (
          <li key={category.id} className="">
            <CategoryCard
              category={category}
              onClick={onCategoryClick}
              selected={selectedCategoryId === category.id}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategoryList;
